import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, Observable, of, take } from 'rxjs';
import { PwaPushNotificationInterface } from '../../interfaces/pwa-push-notification.interface';
import {
    loadPwaPushNotificationSettings,
    offerPushNotificationSubscription,
    subscribeToPushNotifications,
    subscribeToPushNotificationsFailure,
    subscribeToPushNotificationsSuccess,
} from '../../state/pwa-push-notification/actions/pwa-push-notification.actions';
import { selectPwaPushNotificationSettled } from '../../state/pwa-push-notification/selectors/pwa-push-notification.selector';

@Injectable({
    providedIn: 'root',
})
export class PwaPushNotificationService implements PwaPushNotificationInterface {
    public constructor(
        private readonly store: Store,
        private readonly actions$: Actions,
    ) {}

    public get isInitialized(): boolean {
        return this.store.selectSignal(selectPwaPushNotificationSettled)();
    }

    public init(): Observable<void> {
        this.store.dispatch(loadPwaPushNotificationSettings());
        return of(undefined);
    }

    public pushNotificationSubscribe(): Observable<boolean> {
        this.store.dispatch(subscribeToPushNotifications());
        return this.actions$.pipe(
            ofType(subscribeToPushNotificationsSuccess, subscribeToPushNotificationsFailure),
            take(1),
            map((action) => action.type === subscribeToPushNotificationsSuccess.type),
        );
    }

    public askUserForPushNotificationPermission(): void {
        this.store.dispatch(offerPushNotificationSubscription());
    }
}
